import { Select } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const isMobile = useMediaQuery('(max-width: 600px)');

  const handleLanguageChange = (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
    }
  };

  const languageOptions = [
    { value: 'de', label: isMobile ? '🇩🇪' : '🇩🇪 Deutsch' },
    { value: 'en', label: isMobile ? '🇬🇧' : '🇬🇧 English' },
  ];

  return (
    <Select
      data={languageOptions}
      value={i18n.language}
      onChange={handleLanguageChange}
      w={{ base: 80, sm: 120 }}
    />
  );
}
